import { useStatsig } from '@atlassian/mpac-feature-flags';
import { log, resolveAlgoliaSearchIndex } from '@atlassian/mpac-utils';
import AlgoliaSearch from 'algoliasearch/lite';
import { useEffect, useState } from 'react';
export const useGetAppDetailsFromSearch = _ref => {
  let {
    appId,
    appKey,
    algoliaConfig
  } = _ref;
  const [appData, setAppData] = useState(null);
  const [appDataStatus, setAppDataStatus] = useState('idle');
  const {
    environment: algoliaEnvironment,
    applicationId,
    apiKey
  } = algoliaConfig;
  const searchClient = AlgoliaSearch(applicationId, apiKey);
  const {
    enableAlgoliaCallOnAppListingAndDialogs,
    enableV4SearchIndex
  } = useStatsig();
  const isAlgoliaSearchEnabled = enableAlgoliaCallOnAppListingAndDialogs();
  const shouldFetchAppData = isAlgoliaSearchEnabled && (appId || appKey);
  useEffect(() => {
    async function getAppData() {
      try {
        if (!shouldFetchAppData) {
          return;
        }
        const indexName = resolveAlgoliaSearchIndex(algoliaEnvironment, enableV4SearchIndex());
        const searchParams = {};
        if (appKey) {
          searchParams.facetFilters = ["addonKey:".concat(appKey)];
        }
        if (appId) {
          searchParams.numericFilters = "addonId=".concat(appId);
        }
        setAppDataStatus('loading');
        const response = await searchClient.search([{
          indexName,
          params: searchParams
        }]);
        const {
          hits
        } = response.results[0];
        if (hits && hits.length > 0) {
          setAppData(hits[0]);
          setAppDataStatus('resolved');
        } else {
          setAppDataStatus('rejected');
          log.error('useGetAppDetailsFromSearch', "Empty results from algolia for ".concat(appId || appKey));
        }
      } catch (error) {
        setAppDataStatus('rejected');
        log.error('useGetAppDetailsFromSearch', "Failed to fetch app data from algolia for ".concat(appId || appKey), {
          error
        });
      }
    }
    getAppData();
  }, [algoliaEnvironment, appId, appKey]);
  const loading = appDataStatus === 'loading';
  const error = appDataStatus === 'rejected';
  return {
    loading,
    error,
    appData
  };
};